export enum CeramicsPropertyName {
  Form = 'form',
  Material = 'material',
  Processing = 'processing',
  CementAmount = 'cement_amount',
  ReusedContent = 'reused_content',
}

export enum CeramicsForm {
  BricksAndBlocks = 'Bricks & blocks',
  BricksBeams = 'Bricks beams',
  Tiles = 'Tiles',
}

export enum CeramicsMaterial {
  Clay = 'Clay',
  ExpandedClayConcrete = 'Expanded clay concrete',
  SandLime = 'Sand lime',
}

export enum CeramicsProcessing {
  Standard = 'Sand lime',
  Hardburned = 'Hardburned',
  SecondFiring = 'Second firing',
}

export enum CeramicsCementAmount {
  LessThan10 = '<10 % cement (650-700 kg/m³)',
  From10To14 = '10-14 % cement (700-770 kg/m³)',
  From15To17 = '15-17 % cement (700-770 kg/m³)',
  From18To24 = '18-24 % cement (700-800 kg/m³)',
}

export enum CeramicsProducts {
  StandardBricks = 'boverket_sv-SE_6000000082',
  HardburnedBricks = 'boverket_sv-SE_6000000083',
  SecondFiringBricks = 'boverket_sv-SE_6000000170',
  ExpandedClayConcreteLessThan10 = 'boverket_sv-SE_6000000085',
  ExpandedClayConcrete10To14 = 'boverket_sv-SE_6000000086',
  ExpandedClayConcrete15To17 = 'boverket_sv-SE_6000000087',
  ExpandedClayConcrete18To24 = 'boverket_sv-SE_6000000088',
  SandLimeBricks = 'boverket_sv-SE_6000000084',
  BricksBeams = 'boverket_sv-SE_6000000196',
  Tiles = 'boverket_sv-SE_6000000081',
  ReusedConstruction = 'boverket_sv-SE_6000000174',
}
